export const config = {
  name: "buy-insurance-web",
  publicPath: "/kjop-forsikring/",
};
